import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Zap, Scissors, ChevronRight, ArrowRight } from 'lucide-react';
import YoutubeVideo from '../components/YoutubeVideo';
import { useNavigate, useLocation } from "react-router-dom";


const ProceduresSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  const [videoId, setVideoId] = useState(null);
  const isStandalone = location.pathname === '/procedures';

  const endoscopic = [
    { name: t('procedure1'), video: "VIDEO_ID_1", link: "/endoscopic" },
    { name: t('procedure2'), video: "VIDEO_ID_2", link: '/gastric-balloon' },
  ];

  const surgical = [
    { name: t('procedure3'), video: "VIDEO_ID_3", link: '/lapsleeve-gastrectomy' },
    { name: t('procedure4'), video: "VIDEO_ID_4", link: '/gastric-bypass' },
    { name: t('procedure5'), video: "VIDEO_ID_5", link: '/miniGastricBypass' },
  ];

  return (
    <>

      <section
        id="procedures"
        className={`py-12 md:py-16 bg-white ${isStandalone ? 'pt-28 md:pt-32' : ''}`}
        data-testid="procedures-section"
      >
        <div className="section-container">

          {/* Section Header */}
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
            <span className=" text-[#800000] font-semibold text-sm uppercase tracking-wider">
              {t('procedures_subtitle')}
            </span>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900  p-2">
              {t('procedures_title')}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">

            {/* Endoscopic */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-2xl p-6 md:p-8 border border-blue-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center">
                  <Zap className="w-6 h-6 text-white" />
                </div>

                <h3 className="text-xl font-bold text-slate-900">
                  {t('endoscopic_title')}
                </h3>
              </div>

              <ul className="space-y-3">
                {endoscopic.map((procedure, index) => (
                  <li
                    key={index}
                    className="group flex items-center justify-between bg-white rounded-xl p-4 shadow-sm m-2 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:ring-1 hover:ring-slate-100 cursor-pointer"
                    onClick={() => {
                      setVideoId(procedure.video);
                      navigate(procedure.link);
                    }}
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-rose-50 transition-colors duration-300">
                        <ChevronRight className="w-5 h-5 text-blue-500 group-hover:text-[#800000] transition-colors duration-300" />
                      </div>
                      <span className="text-slate-700 font-medium text-left group-hover:text-[#800000] transition-colors duration-300">
                        {procedure.name}
                      </span>
                    </div>
                    {/* <ArrowRight className="w-5 h-5 text-slate-300 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 group-hover:text-[#800000] transition-all duration-300" /> */}
                  </li>
                ))}
              </ul>
            </div>

            {/* Surgical */}
            <div className="bg-gradient-to-br from-teal-50 to-teal-100/50 rounded-2xl p-6 md:p-8 border border-teal-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center">
                  <Scissors className="w-6 h-6 text-white" />
                </div>

                <h3 className="text-xl font-bold text-slate-900">
                  {t('surgical_title')}
                </h3>
              </div>

              <ul className="space-y-3">
                {surgical.map((procedure, index) => (
                  <li
                    key={index}
                    className="group flex items-center justify-between bg-white rounded-xl p-4 shadow-sm m-2 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:ring-1 hover:ring-slate-100 cursor-pointer"
                    onClick={() => {
                      setVideoId(procedure.video);
                      navigate(procedure.link);
                    }}
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-rose-50 transition-colors duration-300">
                        <ChevronRight className="w-5 h-5 text-teal-600 group-hover:text-[#800000] transition-colors duration-300" />
                      </div>
                      <span className="text-slate-700 font-medium text-left group-hover:text-[#800000] transition-colors duration-300">
                        {procedure.name}
                      </span>
                    </div>
                    {/* <ArrowRight className="w-5 h-5 text-slate-300 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 group-hover:text-[#800000] transition-all duration-300" /> */}
                  </li>
                ))}
              </ul>
            </div>

          </div>

          {/* Video Player */}
          {videoId && (
            <div className="mt-12">
              <YoutubeVideo videoId={videoId} />
            </div>
          )}

        </div>
      </section>
    </>
  );
};

export default ProceduresSection;
